import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagDevolucaoVendaResponse } from '../../responses/vendas/get-tag-devolucao-venda.response';
import { CreateTagDevolucaoVendaResponse } from '../../responses/vendas/create-tag-devolucao-venda.response';
import { TagDevolucaoVendaRequest } from '../../requests/vendas/tag-devolucao-venda.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class TagDevolucaoVendaService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'TagDevolucaoVenda';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetTagDevolucaoVendaResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetTagDevolucaoVendaResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CreateTagDevolucaoVendaResponse> {
        const url = `${this.apiUrl}/idTagDevolucaoVenda/${id}`;
        return this.httpClient
            .get<CreateTagDevolucaoVendaResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: TagDevolucaoVendaRequest): Observable<CreateTagDevolucaoVendaResponse> {
        return this.httpClient
            .post<CreateTagDevolucaoVendaResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: TagDevolucaoVendaRequest): Observable<CreateTagDevolucaoVendaResponse> {
        const url = `${this.apiUrl}/idTagDevolucaoVenda/${id}`;
        return this.httpClient
            .put<CreateTagDevolucaoVendaResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idTagDevolucaoVenda/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
